import React from 'react';
import { CheckCircle2, Lock } from 'lucide-react';
export function HeroContent() {
  const bullets = ['Windshield replacement, chip repair, side glass, door glass and rear window replacement', 'Free auto glass estimates with help coordinating most insurance claims', 'Certified technicians for cars, trucks, vans, fleets and semi trucks', 'Lifetime vehicle glass workmanship warranty'];
  return <div className="lg:col-span-7 xl:col-span-7 anim-fade-up" data-id="element-206">
      <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-light text-brand-blue text-sm font-medium mb-3" data-id="element-207">
        <span className="relative flex h-2 w-2" data-id="element-208">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-blue opacity-75" data-id="element-209"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-blue" data-id="element-210"></span>
        </span>
        Same-Day Auto Glass Openings Available
      </div>

      <div className="inline-flex flex-wrap items-center gap-x-3 gap-y-1 px-3 py-2 rounded-xl bg-white border border-slate-200 shadow-sm mb-5 text-xs sm:text-sm" aria-label="5-star trusted auto glass service" data-id="element-211">
        <span className="flex items-center gap-0.5 text-amber-500" aria-hidden="true" data-id="element-212">
          <span data-id="element-213">★</span>
          <span data-id="element-214">★</span>
          <span data-id="element-215">★</span>
          <span data-id="element-216">★</span>
          <span data-id="element-217">★</span>
        </span>
        <span className="sr-only" data-id="element-218">5-star rated</span>
        <span className="font-semibold text-navy-900" data-id="element-219">
          Trusted Auto Glass Service in Southeast Michigan
        </span>
        <span className="text-slate-300" aria-hidden="true" data-id="element-220">
          ·
        </span>
        <span className="text-slate-600" data-id="element-221">Family-Owned Since 2000</span>
        <span className="hidden sm:inline text-slate-300" aria-hidden="true" data-id="element-222">
          ·
        </span>
        <span className="hidden sm:inline text-slate-600" data-id="element-223">
          Howell, Ann Arbor & Novi
        </span>
      </div>

      <h1 className="text-4xl sm:text-5xl lg:text-[2.75rem] xl:text-5xl font-extrabold tracking-tight text-navy-900 mb-4 leading-[1.1]" data-id="element-224">
        Auto Glass Repair &{' '}
        <span className="text-brand-blue" data-id="element-225">Windshield Replacement</span> in
        Southeast Michigan
      </h1>

      <p className="text-base lg:text-lg text-slate-600 mb-5 leading-relaxed max-w-2xl" data-id="element-226">
        Cracked windshield, shattered side window, or broken rear glass? Kosin's
        Glass provides free auto glass estimates, certified installation,
        quality glass that meets or exceeds OEM standards, and help working with
        most insurance companies.
      </p>

      <ul className="space-y-2.5 mb-5" data-id="element-227">
        {bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3 anim-slide-in-left-sm" style={{
        animationDelay: `${0.2 + i * 0.1}s`
      }} data-id="element-228">
            <CheckCircle2 className="w-6 h-6 text-brand-blue shrink-0 mt-0.5" data-id="element-229" />
            <span className="text-slate-700 font-medium" data-id="element-230">{bullet}</span>
          </li>)}
      </ul>

      <div className="flex items-center gap-2 text-sm text-slate-500 bg-white/60 inline-flex px-4 py-2 rounded-lg border border-slate-200/60 backdrop-blur-sm" data-id="element-231">
        <Lock className="w-4 h-4 text-slate-400" data-id="element-232" />
        <span data-id="element-233">
          Your information is secure. Kosin's Glass will never share your
          details.
        </span>
      </div>
    </div>;
}